export default __webpack_public_path__ + "static/media/illustra-error-code.0152bb36.png";